<script>
import { ref, onMounted, toRefs, watch, computed, reactive } from "vue";
import { useScrollEffect } from "../functions";
export default {
	props: ["windowWidth", "windowHeight", "scrollTop"],
	setup(props) {
		const { windowWidth, windowHeight, scrollTop } = toRefs(props);

		const container = ref(null);
		const cover = ref(null);
		const textMajor = ref(null);

		const containerHeight = ref(0);
		const imgSrc = reactive({
			pc: require("../assets/launchImg/background_c2.jpg"),
			mobile: require("../assets/launchImg/background_c2_mobile.jpg"),
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});

		const containerCoeff = useScrollEffect(
			-100,
			windowHeight.value,
			100,
			0
		);
		const smallTransfromCoeff = useScrollEffect(
			1 * windowHeight.value,
			3 * windowHeight.value,
			0,
			-30
		);
		const textMajorOPCoeff = useScrollEffect(
			1 * windowHeight.value,
			3 * windowHeight.value,
			1.1,
			-0.5
		);
		const coverCoeff = useScrollEffect(
			1.1 * windowHeight.value,
			1.7 * windowHeight.value,
			-0.5,
			1.1
		);
		const majorCoeff = useScrollEffect(
			0,
			1 * windowHeight.value,
			0,
			0.013 * windowWidth.value + 24.9
		);

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
			});
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (
					innerHeight.value > -100 &&
					innerHeight.value < windowHeight.value
				) {
					container.value.style.backgroundPosition = `center calc(50%${
						windowWidth.value <= 650 ? " - 12vw" : ""
					} + ${nv * containerCoeff.a + containerCoeff.b}px)`;
					textMajor.value.style.filter = `blur(${nv * majorCoeff.a +
						majorCoeff.b}px)`;
					textMajor.value.style.opacity = 1;
				} else if (
					innerHeight.value > 1 * windowHeight.value &&
					innerHeight.value < 3 * windowHeight.value
				) {
					container.value.style.transform = `translateY(${nv *
						smallTransfromCoeff.a +
						smallTransfromCoeff.b}px)`;
					textMajor.value.style.filter = `blur(${nv * majorCoeff.a +
						majorCoeff.b}px)`;
					textMajor.value.style.opacity = `${nv * textMajorOPCoeff.a +
						textMajorOPCoeff.b}`;
				} else if (innerHeight.value >= 3 * windowHeight.value) {
					textMajor.value.style.opacity = 0;
				} else {
					//textMajor.value.style.filter = "blur(0px)";
				}

				if (innerHeight.value > 1.1 * windowHeight.value) {
					cover.value.style.opacity = `${nv * coverCoeff.a +
						coverCoeff.b}`;
				}
			}
		);
		return {
			container,
			windowWidth,
			imgSrc,
			cover,
			textMajor,
		};
	},
};
</script>

<template>
	<section id="description">
		<img
			:src="windowWidth > 650 ? imgSrc.pc : imgSrc.mobile"
			alt="G26全新BMW 4系列Gran Coupé豪華四門跑車"
		/>
		<div
			class="bg_c2 sticky-wrapper"
			ref="container"
			:style="{
				backgroundImage: `url(${
					windowWidth > 650 ? imgSrc.pc : imgSrc.mobile
				})`,
			}"
		>
			<div class="contain-img"></div>
			<div class="text-container">
				<div class="the-4-text">
					<div class="text_major text_en_light" ref="textMajor"
						>4</div
					>
				</div>
			</div>
			<div class="cover" ref="cover"></div>
		</div>
	</section>
	<section id="description-text">
		<div class="sticky-wrapper">
			<p class="title_sub text_ch_medium">
				<span>無須造就，鋒芒自然顯露！</span><br />
				<span
					>全新世代 <span class="text_en_bold">BMW 4 </span>系列
					<span class="text_en_bold"> Gran Coupé，</span></span
				><br />
				<span
					>前衛優雅的絕美流線、寬敞實用的<br
						class="mobile_break"
					/>豪華座艙、俐落沉穩的極致身手，</span
				><br />
				<span>無不展現獨一無二的耀眼風采，獨到鋒格，自成一格！</span>
			</p>
		</div>
	</section>
</template>

<style lang="sass" scoped>
#description
    z-index: 58
    background-color: #010b24
    img
        display: none
    .bg_c2
        width: 100%
        background-size: cover
        background-repeat: no-repeat
        background-position: center calc(50% + 100px)
        // background-position: center calc(50% + 100px + 100.02vw - 509.2px)
        .contain-img
            display: none
            position: absolute
            width: 100%
            height: 35px
            bottom: -35px
            background-color: #010b24
            background-size: 100% 35px
            -webkit-background-size: 100% 35px
            -moz-background-size: 100% 35px
            -o-background-size: 100% 35px
            background-position: center bottom
            background-repeat: no-repeat
            z-index: 90
        .cover
            position: absolute
            width: 100%
            height: 40%
            left: 0
            bottom: -5px
            opacity: 0
            background-image: linear-gradient(0deg, rgba(1,11,36,1) 0%, rgba(1,11,36,1) 20%, rgba(222,0,55,0.4) 75%, rgba(255,0,0,0) 100%)
        .text-container
            position: relative
            width: 100%
            height: 100%
            top: 0
            display: flex
            justify-content: center
            align-items: center
            .the-4-text
                position: relative
                width: calc(0.55 * (52vw + 202.4px))
                height: calc(21.5vw + 216.2px)
                .text_major
                    position: absolute
                    left: 50%
                    top: 50%
                    transform: translate(-50%, -50%)
                    height: 100%
                    width: 100%
                    font-size: calc(52vw + 202.4px)
                    line-height: calc(21.5vw + 216.2px)
                    mix-blend-mode: difference
                    z-index: 110
                    color: #00ceff

#description-text
    z-index: 58
    .sticky-wrapper
        width: 100%
        .title_sub
            position: relative
            top: 75%
            font-size: 1.7rem
            line-height: 2.12
            letter-spacing: 2.04px
            text-align: center
            z-index: 70
            span
                font-size: inherit
                &.text_en_bold
                    letter-spacing: 1.28px
            .mobile_break
                display: none

@media screen and (max-width: 1440px)
    #description-text
        .sticky-wrapper
            .title_sub
                top: 73%
                // transform: scale(0.9)
@media screen and (max-width: 1200px)
    #description-text
        .sticky-wrapper
            .title_sub
                // transform: scale(1)
@media screen and (max-width: 768px)
    #description-text
        .sticky-wrapper
            .title_sub
                font-size: 1.2rem
                line-height: 2.08
                letter-spacing: 1.2px
                .mobile_break
                    display: block
                    &.comma
                        display: inline
                .pc_break
                    display: none
@media screen and (max-width: 650px)
    #description
        .bg_c2
            background-size: 100% auto
            background-position: center calc(50% - 12vw + 100px)
            .contain-img
                display: block
            .main-cover
                top: calc(2.6vw + 300px + 52.7% - 367px)
            .cover
                height: 80%
    #description-text
        .sticky-wrapper
            .title_sub
                // top: calc(2.6vw + 310px + 146.2px + 51.9% - 361.6px)
                top: 65%
</style>
